module.exports = __webpack_public_path__ + "img/roll_item2.d331db51.png";